/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.ts, reducers wouldn't be hot reloadable.
 */

import { combineReducers } from 'redux';

import { reducer as eddr } from './Eddr';
import { reducer as graphs } from './Graphs';
import { reducer as performance } from './Performance';
import { reducer as user } from './User';
import { reducer as wells } from './Wells';
import { RootState } from './types';

export default combineReducers<RootState>({
  user,
  wells,
  performance,
  graphs,
  eddr,
});
